// extracted by mini-css-extract-plugin
var _1 = "RatePhoneCallModal-module__comment--tVSTe";
var _2 = "RatePhoneCallModal-module__isFilled--gZzek";
var _3 = "RatePhoneCallModal-module__star--hGxvi";
var _4 = "RatePhoneCallModal-module__stars--G3Rym";
var _5 = "RatePhoneCallModal-module__visible--Ag2py";
export { _1 as "comment", _2 as "isFilled", _3 as "star", _4 as "stars", _5 as "visible" }
